export default {
    active: true,
    seed: 17,
    skyType: "gradient",
    skyColor: "#14645f",
    horizonColor: "#a3dab8",
    lighting: "point",
    lightPosition: { x: 0.1, y: 4, z: 0.56 },
    fog: 0.73,
    flatShading: false,
    playArea: 1,
    ground: "noise",
    groundYScale: 0.81,
    groundTexture: "none",
    groundColor: "#ae3241",
    groundColor2: "#db4453",
    dressing: "mushrooms",
    dressingAmount: 150,
    dressingColor: "#a9313d",
    dressingScale: 5,
    dressingVariance: { x: 5, y: 10, z: 5 },
    dressingUniformScale: true,
    dressingOnPlayArea: 0,
    grid: "dots",
    gridColor: "#239893",
    shadow: false,
};
